<script lang="ts">
  let { saving, error, onAccept, onDecline } = $props<{
    saving: boolean;
    error: string;
    onAccept: () => void;
    onDecline: () => void;
  }>();
</script>

<main class="updated-fund-terms">
  <section>
    <small>FUND EARLY ACCESS</small>
    <h1>Updated setup terms</h1>
    <p>Daniel and Jojo at Dealton may use your IR workspace during testing, including reading relevant work mail and creating, editing or deleting LP records, notes, briefings and review-only drafts. Their actions are audited. Changes in Dealton may remain when early access ends.</p>
    <p>Your connected mailbox stays read-only. No email is sent, scheduled, saved to mailbox Drafts or changed.</p>
    <p class="links">By continuing, you agree to the <a href="https://dealton.ai/terms.html" target="_blank" rel="noopener noreferrer">Terms of Service</a> and <a href="https://dealton.ai/privacy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a> with these Fund early-access uses.</p>
    {#if error}<p class="error" role="alert">{error}</p>{/if}
    <button type="button" onclick={onAccept} disabled={saving}>{saving ? 'Saving…' : 'Agree and continue'}</button>
    <button class="secondary" type="button" onclick={onDecline} disabled={saving}>Not now</button>
  </section>
</main>

<style>
  .updated-fund-terms { min-height: 100dvh; display: grid; place-items: center; padding: 24px; background: #0c0a0d; color: #f0edf1; }
  section { width: min(100%, 490px); border: 1px solid #322d34; border-radius: 12px; padding: 32px; background: #161318; box-shadow: 0 18px 50px #0005; }
  small { color: #9a929e; font-size: 11px; letter-spacing: .1em; }
  h1 { margin: 14px 0 20px; font-size: 23px; font-weight: 600; }
  p { color: #aaa2ae; font-size: 14px; line-height: 1.65; }
  .links { font-size: 12px; }
  a { color: #f27b63; }
  .error { color: #ff9a8a; }
  button { margin-top: 14px; border: 0; border-radius: 6px; background: #e95d42; color: white; padding: 11px 18px; cursor: pointer; }
  button:disabled { opacity: .65; cursor: wait; }
  .secondary { margin-left: 12px; background: transparent; color: #aaa2ae; border: 1px solid #403942; }
</style>
